import { defineStore } from 'pinia';
import { API } from '@Providers';

interface State {
  endpoint: string;
  loading: boolean;
  rolesAndPermissions: any;
  staffUserData: any;
  tasks: any[];
}

export default defineStore('staff', {
  state: (): State => ({
    endpoint: '',
    loading: false,
    rolesAndPermissions: {},
    staffUserData: {},
    tasks: [],
  }),

  getters: {
    shelterId: (state) => state.staffUserData?.shelter_id,
  },

  actions: {
    fetchPageDataService() {
      if (!this.endpoint) return;

      const endpoint = `/api/shelter/users/get-profile/${this.endpoint}`;

      return API({ endpoint }).then((result: any) => {
        this.staffUserData = result;
      });
    },

    getRolesAndPermissions() {
      const endpoint = '/api/shelter/users/get-roles';

      return API({ endpoint }).then((result: any) => {
        this.rolesAndPermissions = result;
      });
    },

    async getStaffUserTasks(status: string) {
      this.loading = true;
      const endpoint = `/api/shelter/tasks/new-get-tasks/${status}?id=${this.staffUserData._id}&collection=tasks&forAnimals=false`;

      return await API({ endpoint }).then((result: any) => {
        this.tasks = result;
        this.tasks.reverse();
        this.loading = false;
      });
    },

    fetchData() {
      this.loading = true;

      Promise.all([this.fetchPageDataService(), this.getRolesAndPermissions()])
        .catch((error) => {
          throw error;
        })
        .finally(() => (this.loading = false));
    },

    refreshData() {
      this.fetchData();
    },

    refreshTasks() {
      this.getStaffUserTasks('active');
    },
  },
});
